import React, { useState } from 'react'
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Modal, Box, IconButton, TextField, Grid, FormControl, MenuItem, Select, Tooltip } from '@mui/material';
import MultiClientSelect from '../../../../components/DemoTabs/MultiClientSelect';
import CheckBoxSec from '../../../../pages/Settings/General-Settings/CheckBoxSec';
import ToggleSwitch from '../../../../components/ToggleSwitch/ToggleSwitch';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
const BreakPolicyPop = ({ openPolicyPop, handleClosePolicyPop }) => {
    const modalMoveActivities = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '586px',
        width: '90%',
        margin: 'auto',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: '2px',
        // border: '2px solid #0B57D0'
        border: '2px solid transparent',
        backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        borderRadius: '12px',
    };

    const [dropDownVal, setDropDownVal] = useState('');
    const [restrictVal, setrestrictVal] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const users = [
        { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Alice Smith', image: null },
        { name: 'Mike Johnson', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: 'Mike2 Johnson', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: 'Mike3 Johnson', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
        { name: 'Mike4 Johnson', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
    ];

    const restictionsItems = [
        {
            options: 'No restrictions',
        },
        {
            options: 'Once per work Session',
        },
        {
            options: 'Allow within every few hours',
        },
        {
            options: 'Allow after every few hours',
        },
    ]
    return (
        <>

            <Modal open={openPolicyPop} fullWidth maxWidth="sm">
                <Box sx={{
                    ...modalMoveActivities,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '90vh',
                    overflow: 'hidden',
                }}>
                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                        <Box>
                            <Typography variant="h6" fontSize={'17px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Add work break policy</Typography>
                        </Box>
                        <IconButton onClick={handleClosePolicyPop} className='p-0'>
                            <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                        </IconButton>
                    </Box>
                    {/* End Header */}

                    {/* start Body sec  */}
                    <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '15px' }} dividers>
                        <Box sx={{ marginBottom: '20px' }}>
                            <Grid container spacing={1}>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600}  sx={{ fontSize: '14px', margin: '4px auto', fontWeight: '600', fontFamily: 'Manrope' }}>Policy Name</Typography>
                                        <TextField placeholder="Enter a name for the policy (ex: Rest or Lunch)" fullWidth size="small" fontWeight={400}
                                            sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope' }} />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', margin: '4px auto', fontWeight: '600', fontFamily: 'Manrope' }}>Teams / Members</Typography>
                                        <MultiClientSelect label="Select Team Members" options={users} selectedValues={selectedUsers} onChange={setSelectedUsers} />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px', display: 'flex', alignItems: 'center' , marginTop: '-15px' }}>
                                        <CheckBoxSec projects={[{ name: true }]} />
                                        <Typography sx={{ color: '#64748B', fontSize: '14px', fontWeight: '400' }}>Automatically add new members to this poicy</Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', margin: '4px auto', fontWeight: '600', fontFamily: 'Manrope' }}>Type</Typography>
                                        <FormControl fullWidth>
                                            <Select
                                                sx={{
                                                    height: '40px',
                                                    borderRadius: '6px',
                                                    margin: '4px 0',
                                                }}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={dropDownVal}
                                                onChange={(e) => setDropDownVal(e.target.value)}
                                                displayEmpty
                                            >
                                                <MenuItem value={''}>Paid</MenuItem>
                                                <MenuItem value={20}>Unpaid</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', margin: '4px auto', fontWeight: '600', fontFamily: 'Manrope' }}>Allotted Duration</Typography>
                                        <TextField type='time' placeholder="Enter a name for the policy (ex: Rest or Lunch)" fullWidth size="small" fontWeight={400}
                                            sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope' }} />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', margin: '4px auto', fontWeight: '600', fontFamily: 'Manrope' }}>Restrictions</Typography>
                                        <FormControl fullWidth>
                                            <Select
                                                sx={{
                                                    height: '40px',
                                                    borderRadius: '6px',
                                                    margin: '4px 0',
                                                }}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={restrictVal}
                                                onChange={(e) => setrestrictVal(e.target.value)}
                                                displayEmpty
                                                renderValue={(select) => {
                                                    if (!select) {
                                                        return <Typography sx={{ fontSize: '14px', color: '#1A1F36' }}>Select Options</Typography>
                                                    }
                                                    else {
                                                        return <Typography sx={{ fontSize: '14px', color: '#1A1F36' }}>{select}</Typography>
                                                    }
                                                }}

                                            >
                                                {
                                                    restictionsItems.map((curElem => (
                                                        <MenuItem value={curElem.options}>{curElem.options}</MenuItem>
                                                    )))
                                                }
                                            </Select>
                                        </FormControl>
                                        <Typography sx={{ color: '#1A1F36', fontSize: '13px', fontWeight: '400' }}>This cannot be edited once the policy has been created.</Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', margin: '4px auto', fontWeight: '600', fontFamily: 'Manrope' }}>Repeats every</Typography>
                                        <TextField type='time' placeholder="Repeats every" fullWidth size="small" fontWeight={400}
                                            sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope' }} />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Box>
                                                    <ToggleSwitch />
                                                </Box>
                                                <Box>
                                                    <Typography sx={{ color: '#1A1F36', fontSize: '14px', fontWeight: '600' }}>
                                                        After working at least
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <TextField type='text' sx={{
                                                    '& .MuiInputBase-formControl': {
                                                        height: '40px',
                                                        borderRadius: '6px'
                                                    }
                                                }} />
                                                <Typography sx={{ color: '#1A1F36', fontSize: '14px', fontWeight: '400' }}>Hrs</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '20px auto 5px' }}>
                                        <Box sx={{ height: '12px', background: '#D9D9D9', width: '100%' }}>
                                            <Box sx={{ height: '12px', background: '#4CAF50', width: '20%', margin: 'auto' }}></Box>
                                        </Box>
                                        <Typography sx={{ textAlign: 'center', fontSize: '14px', marginTop: '3px', color: '#64748B', fontWeight: '400' }}>1st break available</Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '20px auto 5px' }}>
                                        <Box sx={{ m: '0 auto 5px', display: 'flex', alignItems: 'center' }}>
                                            <CheckBoxSec projects={[{ name: true }]} />
                                            <Typography sx={{ color: '#64748B', fontSize: '14px', fontWeight: '400' }}>Notify members about their breaks </Typography>
                                            <Tooltip title="Notifications are sent via our Mobile and Desktop apps" arrow placement="top" alignContent="center">
                                                <button className="tooltipBtn  border-0 bg-transparent p-0">
                                                    <InfoOutlineIcon fontSize="small" sx={{marginBottom: '3px'}} />
                                                </button>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>

                    {/* End Body sec  */}

                    {/* start Footer sec  */}
                    <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                        <Button onClick={handleClosePolicyPop} variant="outlined" className='bg-white text-capitalize' color="#1A1F36" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                            Cancel
                        </Button>
                        <Box display="flex" alignItems="center" sx={{ gap: '14px' }}>
                            <Button variant="contained" color="primary" className='text-capitalize' sx={{ boxShadow: 'unset', backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                                Save
                            </Button>
                        </Box>
                    </Box>
                    {/* End Footer sec  */}
                </Box>
            </Modal>
        </>
    )
}

export default BreakPolicyPop